export const faqItems = [
  {
    id: "faq-1",
    question: "桃子视频是否需要注册才能观看？",
    answer: "桃子视频所有影视资源均支持免注册在线观看，打开网站即可直接浏览和播放。注册会员后可享受收藏片单、观看历史和个性化推荐等额外功能。",
  },
  {
    id: "faq-2",
    question: "红桃视频和黑桃视频有什么区别？",
    answer: "红桃视频主打温情、爱情与家庭伦理题材；黑桃视频侧重悬疑、惊悚与犯罪探案类内容。各频道按情感色彩分类，帮助观众快速找到符合当下心情的影视作品。",
  },
  {
    id: "faq-3",
    question: "视频播放卡顿怎么办？",
    answer: "桃子视频采用多线路智能调度技术，当检测到当前线路延迟时会自动切换最优节点。您也可以手动在播放器右下角切换备用线路，确保观影流畅不卡顿。",
  },
  {
    id: "faq-4",
    question: "影视资源多久更新一次？",
    answer: "热门电视剧和综艺节目通常24小时内同步更新，电影资源根据院线下映和流媒体上线时间每天滚动上新。首页「最近更新」模块可实时查看最新入库内容。",
  },
  {
    id: "faq-5",
    question: "支持哪些设备观看桃子视频？",
    answer: "桃子视频全面适配桌面电脑、平板和手机浏览器，无需安装任何插件。移动端访问会自动切换为触屏优化界面，随时随地畅享高清观影体验。",
  },
];

export const cardItems = [
  {
    id: "card-1",
    title: "红桃剧场",
    desc: "温情治愈系影视专区，汇集国内外高分爱情片、家庭伦理剧，伴你度过每个温暖夜晚。",
    tags: ["爱情", "家庭", "治愈"],
    views: "128.6万",
    img: "https://readdy.ai/api/search-image?query=Warm%20romantic%20cinematic%20scene%20with%20soft%20pink%20and%20peach%20lighting%2C%20couple%20silhouette%20against%20sunset%2C%20film%20grain%20texture%2C%20dreamy%20atmosphere%2C%20editorial%20photography%20style%20with%20elegant%20composition&width=800&height=500&seq=card-hongtao-01&orientation=landscape",
  },
  {
    id: "card-2",
    title: "黑桃悬疑",
    desc: "高能反转烧脑剧集，精选全球悬疑、犯罪、惊悚佳作，每一帧都让你屏息凝神。",
    tags: ["悬疑", "犯罪", "烧脑"],
    views: "96.3万",
    img: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20scene%20with%20shadowy%20alley%20at%20night%2C%20single%20streetlamp%20casting%20dramatic%20light%2C%20film%20noir%20style%2C%20suspenseful%20atmosphere%2C%20movie%20poster%20aesthetic%20with%20deep%20contrast&width=800&height=500&seq=card-heitao-02&orientation=landscape",
  },
  {
    id: "card-3",
    title: "桃花综艺",
    desc: "轻松欢乐综艺大本营，脱口秀、真人秀、音乐竞演一网打尽，笑声不断精彩不停。",
    tags: ["综艺", "搞笑", "真人秀"],
    views: "215.4万",
    img: "https://readdy.ai/api/search-image?query=Bright%20joyful%20variety%20show%20stage%20with%20colorful%20lights%20and%20confetti%2C%20entertainment%20atmosphere%2C%20warm%20peach%20and%20coral%20tones%2C%20lively%20crowd%20silhouette%2C%20modern%20TV%20studio%20aesthetic&width=800&height=500&seq=card-taohua-03&orientation=landscape",
  },
  {
    id: "card-4",
    title: "红杏出墙",
    desc: "都市情感话题剧集专区，聚焦当代男女情感纠葛与成长故事，写实又戳心。",
    tags: ["都市", "情感", "话题"],
    views: "87.9万",
    img: "https://readdy.ai/api/search-image?query=Modern%20urban%20romantic%20drama%20scene%20with%20two%20figures%20standing%20apart%20in%20a%20rainy%20city%20street%2C%20neon%20reflections%20on%20wet%20pavement%2C%20emotional%20tension%2C%20cinematic%20lighting%20with%20warm%20amber%20tones&width=800&height=500&seq=card-hongxing-04&orientation=landscape",
  },
  {
    id: "card-5",
    title: "糖心动漫",
    desc: "热血与治愈并存的二次元天地，日漫新番、国创精品同步追更，糖分十足。",
    tags: ["动漫", "日漫", "国创"],
    views: "156.2万",
    img: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20with%20colorful%20characters%20in%20a%20fantasy%20cityscape%2C%20warm%20sunset%20sky%2C%20playful%20composition%2C%20Japanese%20animation%20aesthetic%20with%20soft%20pastel%20accents&width=800&height=500&seq=card-tangxin-05&orientation=landscape",
  },
  {
    id: "card-6",
    title: "豆花纪录片",
    desc: "人文自然纪录片宝库，从地球脉动到人间烟火，用镜头记录真实世界的感动。",
    tags: ["纪录片", "人文", "自然"],
    views: "63.8万",
    img: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20majestic%20mountain%20landscape%20at%20golden%20hour%2C%20vast%20wilderness%2C%20warm%20natural%20light%2C%20cinematic%20wide%20shot%2C%20National%20Geographic%20style%20photography&width=800&height=500&seq=card-douhua-06&orientation=landscape",
  },
  {
    id: "card-7",
    title: "粉桃少儿",
    desc: "安全健康的儿童影视乐园，精选优质动画、益智节目与亲子电影，守护童年。",
    tags: ["少儿", "动画", "亲子"],
    views: "42.1万",
    img: "https://readdy.ai/api/search-image?query=Colorful%20playful%20children%20animation%20scene%20with%20friendly%20cartoon%20animals%20in%20a%20bright%20magical%20forest%2C%20soft%20pastel%20colors%2C%20happy%20atmosphere%2C%20kids%20movie%20poster%20style%2C%20warm%20and%20inviting&width=800&height=500&seq=card-fentao-07&orientation=landscape",
  },
];

export const topicItems = [
  { id: "t-1", name: "都市情感剧", heat: "🔥 98.7万讨论" },
  { id: "t-2", name: "悬疑烧脑片单", heat: "🔥 86.2万讨论" },
  { id: "t-3", name: "高分韩剧推荐", heat: "🔥 75.4万讨论" },
  { id: "t-4", name: "国产良心剧", heat: "🔥 69.8万讨论" },
  { id: "t-5", name: "周末电影清单", heat: "🔥 63.1万讨论" },
  { id: "t-6", name: "治愈系动漫", heat: "🔥 58.3万讨论" },
  { id: "t-7", name: "真实事件改编", heat: "🔥 52.7万讨论" },
  { id: "t-8", name: "冷门神作挖掘", heat: "🔥 47.5万讨论" },
  { id: "t-9", name: "经典港片重温", heat: "🔥 41.2万讨论" },
  { id: "t-10", name: "女性成长题材", heat: "🔥 38.6万讨论" },
  { id: "t-11", name: "科幻世界观解析", heat: "🔥 34.9万讨论" },
];

export const mediaItems = [
  {
    id: "media-1",
    title: "《桃花源记》独家纪录片：幕后拍摄全揭秘",
    desc: "走进剧组拍摄现场，看导演如何用光影重现陶渊明笔下的世外桃源，全程高能不容错过。",
    duration: "48:32",
    views: "326.5万",
    img: "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20documentary%20shot%20with%20film%20crew%20working%20on%20a%20period%20drama%20set%2C%20warm%20lighting%20setup%2C%20professional%20camera%20equipment%2C%20artistic%20composition%2C%20movie%20production%20atmosphere&width=1200&height=675&seq=media-doc-01&orientation=landscape",
  },
  {
    id: "media-2",
    title: "红桃精选：本年度最值得二刷的十部爱情电影",
    desc: "从青涩初恋到白头偕老，十部跨越不同时代的爱情经典，每部都值得反复品味。",
    duration: "22:15",
    views: "198.7万",
    img: "https://readdy.ai/api/search-image?query=Romantic%20film%20montage%20collage%20with%20soft%20warm%20lighting%2C%20couple%20embracing%20in%20golden%20sunset%2C%20vintage%20cinema%20aesthetic%2C%20film%20strip%20border%2C%20nostalgic%20atmosphere%20with%20peach%20tones&width=1200&height=675&seq=media-romance-02&orientation=landscape",
  },
  {
    id: "media-3",
    title: "黑桃探案：真实案件改编影视作品深度盘点",
    desc: "从韩国华城连环案到白银市连环案，真实比虚构更令人战栗的罪案改编盘点。",
    duration: "35:08",
    views: "267.3万",
    img: "https://readdy.ai/api/search-image?query=Crime%20investigation%20documentary%20style%20scene%20with%20evidence%20board%20and%20red%20strings%20connecting%20photos%2C%20dimly%20lit%20room%2C%20detective%20aesthetic%2C%20true%20crime%20atmosphere%2C%20moody%20cinematic%20lighting&width=1200&height=675&seq=media-crime-03&orientation=landscape",
  },
];

export const updatesItems = [
  {
    id: "up-1",
    date: "07-30",
    title: "《繁花深处》第28集更新上线，剧情迎来重大转折",
    tag: "热剧更新",
  },
  {
    id: "up-2",
    date: "07-29",
    title: "黑桃悬疑频道新增三部高口碑韩国犯罪片",
    tag: "片库上新",
  },
  {
    id: "up-3",
    date: "07-28",
    title: "糖心动漫专区同步上线七月新番，共12部作品首播",
    tag: "新番上线",
  },
  {
    id: "up-4",
    date: "07-27",
    title: "播放器升级至v4.2版本，新增智能画质增强功能",
    tag: "功能升级",
  },
  {
    id: "up-5",
    date: "07-26",
    title: "豆花纪录片《山河万里的味》全集一次性上线",
    tag: "专题上线",
  },
  {
    id: "up-6",
    date: "07-25",
    title: "红桃剧场七夕专题策划启动，精选50部经典爱情片",
    tag: "活动预告",
  },
  {
    id: "up-7",
    date: "07-24",
    title: "桃花综艺频道引入三档全新脱口秀节目独家播出",
    tag: "独家引进",
  },
  {
    id: "up-8",
    date: "07-23",
    title: "服务器节点扩容完成，晚高峰观影流畅度提升40%",
    tag: "体验优化",
  },
];

export const featureItems = [
  {
    id: "feat-1",
    icon: "ri-movie-2-line",
    title: "海量片库",
    desc: "覆盖红桃、黑桃、桃花、红杏、糖心、豆花等十余个频道，收录超过十万部影视资源，每日持续更新。",
  },
  {
    id: "feat-2",
    icon: "ri-4k-line",
    title: "高清画质",
    desc: "全站支持1080P超清播放，热门内容提供4K画质选项，智能自适应码率确保流畅观影。",
  },
  {
    id: "feat-3",
    icon: "ri-flashlight-line",
    title: "不卡顿",
    desc: "全球多节点CDN加速配合智能线路调度，晚高峰也能流畅播放，告别缓冲等待。",
  },
  {
    id: "feat-4",
    icon: "ri-smartphone-line",
    title: "全端适配",
    desc: "桌面、平板、手机三端完美适配，触屏手势操作优化，随时随地享受大屏观影体验。",
  },
  {
    id: "feat-5",
    icon: "ri-shield-check-line",
    title: "安全无广告",
    desc: "纯净观影环境，无弹窗、无强制广告、无恶意跳转，专注内容本身，守护每一次观影。",
  },
];

export const rankingItems = [
  { rank: 1, title: "繁花深处", channel: "红桃剧场", heat: "986.5万", trend: "up" },
  { rank: 2, title: "暗夜追踪者", channel: "黑桃悬疑", heat: "874.2万", trend: "up" },
  { rank: 3, title: "桃花朵朵开 第三季", channel: "桃花综艺", heat: "762.8万", trend: "up" },
  { rank: 4, title: "都市夜未眠", channel: "红杏出墙", heat: "651.3万", trend: "down" },
  { rank: 5, title: "星河战队：重生", channel: "糖心动漫", heat: "543.7万", trend: "up" },
  { rank: 6, title: "舌尖上的故乡", channel: "豆花纪录片", heat: "432.1万", trend: "up" },
  { rank: 7, title: "小猪佩奇大电影", channel: "粉桃少儿", heat: "321.6万", trend: "down" },
];

export const commentItems = [
  {
    id: "cm-1",
    name: "影迷小陈",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
    text: "用了桃子视频快两年了，片源更新速度真的快，热门剧基本隔天就能看。最重要的是不卡顿，以前用别的平台晚上看个电影要缓冲半天，这边丝滑得很。",
    date: "3天前",
  },
  {
    id: "cm-2",
    name: "追剧达人",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20avatar%2C%20soft%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
    text: "红桃剧场的选片品味真的绝！每次剧荒就来逛一圈，总能挖到宝藏。最近在追《繁花深处》，每天蹲更新，完全停不下来。",
    date: "5天前",
  },
  {
    id: "cm-3",
    name: "深夜观影人",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    text: "黑桃悬疑频道是我的快乐老家，各种烧脑剧和真实案件改编看得很过瘾。分类做得很好，想找什么类型一目了然，比漫无目的搜方便太多。",
    date: "1周前",
  },
  {
    id: "cm-4",
    name: "动漫控阿琳",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20avatar%2C%20soft%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish",
    text: "糖心动漫的新番同步速度太感人了，日本那边刚播完这边就有熟肉。画质也很能打，投屏到电视上看简直享受，已经安利给整个宿舍了！",
    date: "1周前",
  },
  {
    id: "cm-5",
    name: "纪录片爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-05&orientation=squarish",
    text: "豆花纪录片的片库品质很高，BBC和国家地理的经典都有收录。周末泡杯茶看一部高分纪录片，比刷短视频有意义多了。希望继续保持更新！",
    date: "2周前",
  },
];

export const carouselItems = [
  {
    id: "car-1",
    title: "暑期档爆款：《繁花深处》",
    desc: "一部讲述九十年代上海滩商海沉浮的年代大剧，全网播放量突破50亿。王家卫风格浓郁，每一帧都像精心构图的摄影作品。",
    tag: "热播榜首",
    img: "https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20scene%20set%20in%201990s%20Shanghai%2C%20elegant%20figure%20in%20cheongsam%20by%20the%20Bund%20at%20dusk%2C%20warm%20golden%20light%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20romantic%20nostalgic%20atmosphere&width=1400&height=700&seq=carousel-fanhua-01&orientation=landscape",
  },
  {
    id: "car-2",
    title: "黑桃精选：年度悬疑大作",
    desc: "改编自真实悬案的国产犯罪片《暗夜追踪者》，三条时间线交错叙事，反转不断，播出三天即登顶热门榜。",
    tag: "口碑爆款",
    img: "https://readdy.ai/api/search-image?query=Mysterious%20crime%20thriller%20scene%20with%20a%20detective%20standing%20in%20rain%20under%20a%20streetlamp%20at%20night%2C%20film%20noir%20lighting%2C%20dark%20alley%20with%20fog%2C%20tense%20atmosphere%2C%20Korean%20crime%20movie%20aesthetic&width=1400&height=700&seq=carousel-crime-02&orientation=landscape",
  },
  {
    id: "car-3",
    title: "桃花综艺：夏日爆笑特辑",
    desc: "《桃花朵朵开》第三季重磅回归，全新嘉宾阵容带来前所未有的化学反应，首期收视即破纪录。",
    tag: "综艺新番",
    img: "https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20stage%20with%20confetti%20and%20cheering%20crowd%2C%20entertainment%20lights%2C%20joyful%20summer%20atmosphere%2C%20TV%20studio%20with%20vibrant%20set%20design%2C%20Korean%20variety%20show%20aesthetic&width=1400&height=700&seq=carousel-variety-03&orientation=landscape",
  },
  {
    id: "car-4",
    title: "糖心动漫：七月新番狂欢",
    desc: "十二部全新番剧同步开播，热血战斗、治愈日常、奇幻冒险一应俱全，二次元盛会不容错过。",
    tag: "新番上线",
    img: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20cityscape%20at%20sunset%20with%20diverse%20colorful%20characters%20gathered%20together%2C%20fantasy%20elements%2C%20warm%20lighting%2C%20dynamic%20composition%2C%20Japanese%20animation%20movie%20poster%20style&width=1400&height=700&seq=carousel-anime-04&orientation=landscape",
  },
  {
    id: "car-5",
    title: "豆花纪实：《山河万里的味》",
    desc: "横跨中国三十座城市的顶级美食纪录片，用镜头探寻每座城市最地道的市井味道，豆瓣开分9.2。",
    tag: "高分纪录",
    img: "https://readdy.ai/api/search-image?query=Stunning%20Chinese%20food%20documentary%20scene%20with%20steaming%20street%20food%20in%20ancient%20alley%2C%20warm%20golden%20light%2C%20traditional%20market%20atmosphere%2C%20mouth%20watering%20dishes%2C%20rich%20textures%2C%20cinematic%20food%20photography&width=1400&height=700&seq=carousel-food-05&orientation=landscape",
  },
];

export const indexItems = [
  {
    id: "idx-1",
    title: "红桃剧场合集",
    desc: "温情爱情、家庭伦理、治愈系影视精选",
    count: "3,286部",
    icon: "ri-heart-line",
  },
  {
    id: "idx-2",
    title: "黑桃悬疑合集",
    desc: "悬疑推理、犯罪惊悚、烧脑反转佳作",
    count: "1,952部",
    icon: "ri-moon-line",
  },
  {
    id: "idx-3",
    title: "桃花综艺合集",
    desc: "脱口秀、真人秀、音乐竞演欢乐不断",
    count: "1,438部",
    icon: "ri-emotion-laugh-line",
  },
  {
    id: "idx-4",
    title: "红杏剧场合集",
    desc: "都市情感、话题剧集、现实题材力作",
    count: "2,104部",
    icon: "ri-fire-line",
  },
  {
    id: "idx-5",
    title: "糖心动漫合集",
    desc: "日漫新番、国创精品、二次元大本营",
    count: "4,672部",
    icon: "ri-star-line",
  },
  {
    id: "idx-6",
    title: "豆花纪录合集",
    desc: "人文自然、历史探秘、BBC经典纪录",
    count: "1,815部",
    icon: "ri-earth-line",
  },
  {
    id: "idx-7",
    title: "粉桃少儿合集",
    desc: "安全动画、益智节目、亲子电影天地",
    count: "2,943部",
    icon: "ri-bear-smile-line",
  },
];

export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "特色优势", href: "#features" },
  { label: "专题合集", href: "#index" },
  { label: "精彩视频", href: "#media" },
  { label: "热门推荐", href: "#cards" },
  { label: "用户评价", href: "#comments" },
];